import React from "react";
import {
  RadioGroup,
  Radio,
  Select,
  Label,
  Checkbox,
  makeStyles,
  Tooltip,
  Button,
} from "@fluentui/react-components";
import { Info16Regular } from "@fluentui/react-icons";
import { CoverageComponentProps } from "./types";

const useStyles = makeStyles({
  infoIcon: {
    marginLeft: "4px",
    verticalAlign: "middle",
    cursor: "help",
  },
  radioGroup: {
    marginBottom: "20px",
  },
  planSection: {
    marginBottom: "20px",
  },
  checkboxSection: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginTop: "20px",
  },
});

const AccidentCoverage: React.FC<CoverageComponentProps<"accident">> = ({
  config,
  onConfigChange,
  t,
  classes,
}) => {
  const styles = useStyles();

  return (
    <>
      {/* Who is covered section */}
      <div className={styles.radioGroup}>
        <Label style={{ marginBottom: "8px", display: "block" }}>
          Who is covered?
        </Label>
        <RadioGroup
          value={config.whoCovered || "driver"}
          onChange={(_, data) =>
            onConfigChange({
              whoCovered: data.value,
            })
          }
        >
          <Radio value="driver" label="Only the driver" />
          <Radio value="allSeats" label="All seats in the vehicle" />
        </RadioGroup>
      </div>

      {/* Injury coverage plan section */}
      <div className={styles.planSection}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Label htmlFor="injuryPlan" style={{ marginBottom: "8px" }}>
            Injury coverage plan:
          </Label>
          <Tooltip
            content={
              <div style={{ maxWidth: "300px" }}>
                <strong>UM:</strong> Basic coverage with medical expenses up to
                100,000 Kč
                <br />
                <strong>US:</strong> Standard coverage with medical expenses up
                to 500,000 Kč
                <br />
                <strong>UV:</strong> Premium coverage with medical expenses up
                to 1,000,000 Kč
              </div>
            }
            relationship="label"
          >
            <Button
              icon={<Info16Regular />}
              appearance="subtle"
              size="small"
              className={styles.infoIcon}
            />
          </Tooltip>
        </div>
        <Select
          id="injuryPlan"
          value={config.injuryPlan || "UM"}
          onChange={(_, data) =>
            onConfigChange({
              injuryPlan: data.value,
            })
          }
          style={{ width: "200px" }}
        >
          <option value="UM">UM</option>
          <option value="US">US</option>
          <option value="UV">UV</option>
        </Select>
      </div>

      {/* Checkbox options */}
      <div className={styles.checkboxSection}>
        <Checkbox
          label="Exclude sleeping places (beds)"
          checked={config.excludeSleepingPlaces || false}
          onChange={(_, data) => {
            onConfigChange({
              excludeSleepingPlaces: data.checked === true,
            });
          }}
        />
        <Checkbox
          label="Include protection for unfaulted accidents (e.g. unknown driver or hit-and-run)"
          checked={config.includeUnfaultedProtection !== false}
          onChange={(_, data) => {
            onConfigChange({
              includeUnfaultedProtection: data.checked === true,
            });
          }}
        />
      </div>
    </>
  );
};

export default AccidentCoverage;
